module.exports = __webpack_public_path__ + "img/rever-isotype-all-blue.aad7121f.svg";